
(function containerTypeControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeModifyController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminContainerTypeService', 'authExtend', 'functionService',
            function containerTypeController($scope, config, $state, $translate, errors, $stateParams, adminContainerTypeService, authExtend, functionService) {
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                $scope.document = {
                    app: []
                };

                $scope.title = 'ContainerTypeModify';

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminContainerTypeService.getById($stateParams.id, 'Put').then(function (result) {
                    $scope.document = result;

                    $scope.document.app = [];
                    $scope.tempApp = [];

                    if ($scope.allApps) {
                        functionService.getApps().then(function getOk(result) {
                            $scope.optionApps = result;

                            if ($scope.optionApps) {
                                $scope.document.applications.forEach(function (item) {
                                    $scope.document.app.push(item.applicationId);

                                    var tempAppItem = $scope.optionApps.filter(function (optionApp) { return optionApp.id == item.applicationId; });
                                    $scope.optionApps[$scope.optionApps.indexOf(tempAppItem[0])].isAlreadyAdded = true;
                                    $scope.tempApp.push(tempAppItem[0]);
                                });
                            }
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }

                }, function (error) {
                    errors.showError(error);
                    $state.go('container-type-find');
                });

                $scope.selectApp = function (item) {
                    if (!Array.isArray($scope.tempApp)) {
                        $scope.tempApp = [];
                    }

                    $scope.document.applications.push({ applicationId: item.id });

                    $scope.tempApp.push(item)
                };

                $scope.removeApp = function (item) {
                    var index = $scope.tempApp.indexOf(item);
                    if (index > -1) {
                        $scope.tempApp.splice(index, 1);
                    }

                    var appItem = $scope.document.applications.filter(function (app) {
                        return app.applicationId == item.id;
                    });
                    var index = $scope.document.applications.indexOf(appItem[0]);
                    if (index > -1 && !appItem[0].id) {
                        $scope.document.applications.splice(index, 1);
                    }

                };

                $scope.save = function () {
                    if (!$scope.containerTypeForm.$valid) {
                        $scope.containerTypeForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    return adminContainerTypeService.modify($scope.document).then(function () {
                        $state.go('container-type-find');
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.cancel = function () {
                    $state.go('container-type-find');
                };
            }
        ]);
})();